"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TransactionMethod;
(function (TransactionMethod) {
    TransactionMethod[TransactionMethod["None"] = 0] = "None";
    TransactionMethod[TransactionMethod["BankTransfer"] = 1] = "BankTransfer";
    TransactionMethod[TransactionMethod["Loan"] = 2] = "Loan";
    TransactionMethod[TransactionMethod["Vipps"] = 4] = "Vipps";
    TransactionMethod[TransactionMethod["Cash"] = 8] = "Cash";
    TransactionMethod[TransactionMethod["Other"] = 16] = "Other";
})(TransactionMethod = exports.TransactionMethod || (exports.TransactionMethod = {}));
var SignatureStatus;
(function (SignatureStatus) {
    SignatureStatus[SignatureStatus["None"] = 0] = "None";
    SignatureStatus[SignatureStatus["Signed"] = 1] = "Signed";
    SignatureStatus[SignatureStatus["Declined"] = 2] = "Declined";
})(SignatureStatus = exports.SignatureStatus || (exports.SignatureStatus = {}));
var InvitationType;
(function (InvitationType) {
    InvitationType[InvitationType["Sms"] = 1] = "Sms";
    InvitationType[InvitationType["Email"] = 2] = "Email";
})(InvitationType = exports.InvitationType || (exports.InvitationType = {}));
var DocumentSignatureSectionType;
(function (DocumentSignatureSectionType) {
    DocumentSignatureSectionType[DocumentSignatureSectionType["Manual"] = 0] = "Manual";
    DocumentSignatureSectionType[DocumentSignatureSectionType["Digital"] = 1] = "Digital";
})(DocumentSignatureSectionType = exports.DocumentSignatureSectionType || (exports.DocumentSignatureSectionType = {}));
var ContractType;
(function (ContractType) {
    ContractType[ContractType["None"] = 0] = "None";
    ContractType[ContractType["Simple"] = 1] = "Simple";
    ContractType[ContractType["Standard"] = 2] = "Standard";
    ContractType[ContractType["Member"] = 4] = "Member";
    ContractType[ContractType["Premium"] = 8] = "Premium";
})(ContractType = exports.ContractType || (exports.ContractType = {}));
var OwnershipTransferStep;
(function (OwnershipTransferStep) {
    OwnershipTransferStep[OwnershipTransferStep["None"] = 0] = "None";
    OwnershipTransferStep[OwnershipTransferStep["ValidationViolation"] = 1] = "ValidationViolation";
    OwnershipTransferStep[OwnershipTransferStep["ValidationError"] = 2] = "ValidationError";
    OwnershipTransferStep[OwnershipTransferStep["ValidationComplete"] = 3] = "ValidationComplete";
    OwnershipTransferStep[OwnershipTransferStep["TransferViolation"] = 4] = "TransferViolation";
    OwnershipTransferStep[OwnershipTransferStep["TransferError"] = 5] = "TransferError";
    OwnershipTransferStep[OwnershipTransferStep["TransferComplete"] = 6] = "TransferComplete";
    OwnershipTransferStep[OwnershipTransferStep["RegistrationViolation"] = 7] = "RegistrationViolation";
    OwnershipTransferStep[OwnershipTransferStep["RegistrationError"] = 8] = "RegistrationError";
    OwnershipTransferStep[OwnershipTransferStep["RegistrationComplete"] = 9] = "RegistrationComplete";
})(OwnershipTransferStep = exports.OwnershipTransferStep || (exports.OwnershipTransferStep = {}));
//# sourceMappingURL=SalesContract.js.map